import { render } from "./viewPage.vue?vue&type=template&id=5c7f40bc&scoped=true"
import script from "./viewPage.vue?vue&type=script&lang=js"
export * from "./viewPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7f40bc"]])

export default __exports__